import { render } from "./GpaPerformanceAfterRemedial.vue?vue&type=template&id=126e4910"
import script from "./GpaPerformanceAfterRemedial.vue?vue&type=script&lang=js"
export * from "./GpaPerformanceAfterRemedial.vue?vue&type=script&lang=js"
script.render = render

export default script